import { useGetNotification } from '@/queries/notification';
import { useGetUser, useHasNotEContractV2 } from '@/queries/user';
import { useGetUserStatus } from '@/userStatus/hooks';

export const useHandleLoggedInUserDisplayWrapper = () => {
  const { isVerified } = useGetUserStatus();

  const { unseenCount } = useGetNotification({
    enabled: isVerified,
  });

  const { data: user } = useGetUser({
    enabled: false,
  });

  const hasNotEContractV2 = useHasNotEContractV2();

  const showPulseBadge = isVerified && (hasNotEContractV2 || unseenCount > 0);

  return {
    user,
    showPulseBadge,
  };
};
